import {StoreItemCategory, StorePresalePackType} from '../../entity_datas/StoreEnums'
import {BaseStoreItem} from '../BaseStoreItem'
import {LobbyImage} from '@colonist/types'
import {TranslationArrayKeys, TranslationObject} from '@colonist/i18n'

export class SISettlerPack extends BaseStoreItem {
    category = StoreItemCategory.PresalePack
    type = StorePresalePackType.SettlerPack
    name: TranslationObject = {key: 'strings:storePage.packs.settler.title'}
    description: TranslationArrayKeys = 'strings:storePage.packs.settler.description'
    price = 999999999
    image = LobbyImage.SettlerPack
}

export class SIColonistPack extends BaseStoreItem {
    category = StoreItemCategory.PresalePack
    type = StorePresalePackType.ColonistPack
    name: TranslationObject = {key: 'strings:storePage.packs.colonist.title'}
    description: TranslationArrayKeys = 'strings:storePage.packs.colonist.description'
    price = 999999999
    image = LobbyImage.ColonistPack
}

export class SIFounderPack extends BaseStoreItem {
    category = StoreItemCategory.PresalePack
    type = StorePresalePackType.FounderPack
    name: TranslationObject = {key: 'strings:storePage.packs.founder.title'}
    description: TranslationArrayKeys = 'strings:storePage.packs.founder.description'
    price = 999999999
    image = LobbyImage.FounderPack
}
